import type { MetaFunction } from "@remix-run/node";
import { getSeoMeta } from "~/utils/seo-meta";
import { SEOLayout } from "~/components/seo/SEOLayout";
import { GameSeoPage } from "~/components/seo/GameSeoPage";
import { GAME_SEO_CONFIG } from "~/utils/seo-game-content";

export const meta: MetaFunction = () => {
  const content = GAME_SEO_CONFIG["hit-the-target"];
  return getSeoMeta({
    title: content.title,
    description: content.description,
    url: "/seo/hit-the-target",
  });
};

export default function SeoHitTheTarget() {
  return (
    <SEOLayout>
      <GameSeoPage content={GAME_SEO_CONFIG["hit-the-target"]} />
    </SEOLayout>
  );
}
